<template>
    <div
        :data-qa="'page-404'"
        class="page-404"
    >
        <ErrorFourHundredFourMessage>
            <slot name="default"></slot>
        </ErrorFourHundredFourMessage>
    </div>
</template>

<script setup lang="ts">
import { useSetStatus } from '@/ssr/plugins/status.ts'
import ErrorFourHundredFourMessage from '@/components/ui/error/ErrorFourHundredFourMessage.vue'

const { setStatus } = useSetStatus()
setStatus(404)
</script>

<style lang="scss" scoped>
.page-404 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20vh 0;
}
</style>
